@if ({zones: zones$ | async, diensten: diensten$ | async}; as data) {
  @if (data.zones && data.diensten) {
    <zah-upsert-thuisverzorger
      [zones]="data.zones"
      [diensten]="data.diensten"
      okLabel="Voeg toe"
      (cancelClicked)="onCancelClicked()"
      (okClicked)="onAddClicked($event)"
      (editDienstenClicked)="onEditDienstenClicked()"
      >
    </zah-upsert-thuisverzorger>
  }
}

